import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  static values = {
    autoOpen: Boolean,
    closeOnEscape: Boolean,
    closeOnBackdrop: Boolean,
    returnFocusSelector: String
  }

  connect() {
    this.dialog = this.element.tagName === "DIALOG" ? this.element : this.element.querySelector("dialog")
    this.boundHandleCancel = this.handleCancel.bind(this)
    this.boundRestoreFocus = this.restoreFocus.bind(this)

    if (this.dialog) {
      this.dialog.addEventListener("cancel", this.boundHandleCancel)
      this.dialog.addEventListener("close", this.boundRestoreFocus)

      if (this.autoOpenValue) {
        this.openDialog(this.dialog)
      }
    }
  }

  disconnect() {
    if (this.dialog) {
      this.dialog.removeEventListener("cancel", this.boundHandleCancel)
      this.dialog.removeEventListener("close", this.boundRestoreFocus)
    }
  }

  show(event) {
    event.preventDefault()
    this.scrollPosition = window.scrollY

    const dialog = document.getElementById(event.params.dialog)
    if (dialog) {
      this.openDialog(dialog)
      window.scrollTo(0, this.scrollPosition)
    }
  }

  hide(event) {
    event.preventDefault()
    const dialog = event.target.closest("dialog")
    if (dialog) {
      dialog.close()
    }
  }

  hideOnBackdrop(event) {
    if (!this.closeOnBackdropValue) {
      return
    }

    const dialog = event.currentTarget
    const modalContent = dialog.querySelector("[data-modal-content]")

    if (modalContent && !modalContent.contains(event.target)) {
      event.preventDefault()
      dialog.close()
    }
  }

  handleCancel(event) {
    if (!this.closeOnEscapeValue) {
      event.preventDefault()
    }
  }

  restoreFocus() {
    if (this.hasReturnFocusSelectorValue) {
      const returnFocus = document.querySelector(this.returnFocusSelectorValue)
      if (returnFocus) {
        returnFocus.focus()
      }
    }
  }

  openDialog(dialog) {
    if (!dialog.open) {
      dialog.showModal()
    }

    const initialFocus = dialog.querySelector("[data-modal-initial-focus]")
    if (initialFocus) {
      initialFocus.focus()
    }
  }
}
